/**
 * Cheap DICOM detection with no dicom-parser dependency, shared by the import
 * classifier (group-by-study.ts) and the import dialog, which only needs to
 * count and filter the picked files.
 */
/** A DICOM Part 10 file carries "DICM" right after its 128-byte preamble. */
const DICM_OFFSET = 128;
const DICM_MAGIC = [0x44, 0x49, 0x43, 0x4d];
export async function hasDicmMagic(file) {
    if (file.size < DICM_OFFSET + DICM_MAGIC.length)
        return false;
    try {
        const bytes = new Uint8Array(await file.slice(DICM_OFFSET, DICM_OFFSET + DICM_MAGIC.length).arrayBuffer());
        return DICM_MAGIC.every((byte, i) => bytes[i] === byte);
    }
    catch {
        return false;
    }
}
/** DICOMDIR is a CD's index: a Part 10 file with no image in it. */
export function isDicomDir(file) {
    return file.name.toUpperCase() === 'DICOMDIR';
}
/**
 * DICOM by name or MIME type, else by the Part 10 header. A modality CD names
 * its images IM000001 or after their UIDs, with no .dcm and no MIME type, so
 * the header is what recognises them.
 */
export async function isDicomFile(file) {
    if (file.name.toLowerCase().endsWith('.dcm'))
        return true;
    if (file.type === 'application/dicom')
        return true;
    if (isDicomDir(file))
        return false;
    return hasDicmMagic(file);
}
